import { motion } from 'motion/react'
import { staggerContainer, staggerItem } from '@/lib/motion/variants'
import type { Run } from '@/lib/types'
import { CompetitorGrid } from './CompetitorGrid'
import { HowWeScore } from './HowWeScore'
import { PlatformBreakdown } from './PlatformBreakdown'
import { ScoreHero } from './ScoreHero'
import { ShareOfVoice } from './ShareOfVoice'
import { VisibilityRate } from './VisibilityRate'

export function Overview({ run }: { run: Run }) {
  const totalQueries = run.perQuery.length

  return (
    <motion.div
      variants={staggerContainer}
      initial="hidden"
      animate="shown"
      className="space-y-6"
    >
      <motion.div variants={staggerItem} className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <VisibilityRate scores={run.scores} totalQueries={totalQueries} />
        </div>
        <ScoreHero scores={run.scores} />
      </motion.div>

      <motion.div variants={staggerItem}>
        <HowWeScore />
      </motion.div>

      <motion.div variants={staggerItem} className="grid lg:grid-cols-2 gap-6">
        <ShareOfVoice scores={run.scores} trackedBrand={run.brand} />
        <PlatformBreakdown scores={run.scores} totalQueries={totalQueries} />
      </motion.div>

      <motion.div variants={staggerItem}>
        <CompetitorGrid
          competitors={run.competitors}
          scores={run.scores}
          trackedBrand={run.brand}
        />
      </motion.div>
    </motion.div>
  )
}
